import React, { useState } from "react";
import { useFormContext, useFieldArray, FormProvider } from "react-hook-form";
import { Button } from "antd";
import Select from "react-select";
import { Delete, Edit, Info, PlusCircle, Trash2 } from "react-feather";
import { format } from "date-fns";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import ImageUploader from "Components/UI/ImageUploder";
import { Link } from "react-router-dom";
import WorkingHoursPopup from "Components/Modal/working-hours-popup";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useGetCompanySettingQuery } from "AppQuries/setting/company-settings";
import useTimeConverter from "core/Operations/useTimeConverter";
import {
  useFormattedShiftPolicyOption,
  useFormattedShiftTypeOption,
} from "core/Operations/formattedOption/useFormattedMasterOptions";
const activestatus = [
  { id: true, label: "Yes", value: true },
  { id: false, label: "No", value: false },
];

const workingDaysOption = [
  { id: "1", label: "5 Days", value: 5 },
  { id: "2", label: "5.5 Days", value: 5.5 },
  { id: "3", label: "6 Days", value: 6 },
];

const WorkingHours = () => {
  const userData = useSelector(loggedInUser);
  const { timeStringToArithFloat, floatToTimeString } = useTimeConverter();
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const [show, setShow] = useState(false);

  const { data: companyDetails } = useGetCompanySettingQuery({
    companyCode: userData.companyCode,
  });

  const defaultShiftOptions = useFormattedShiftPolicyOption({
    companyCode: userData.companyCode,
    locationCode: userData.selectedLocationCode,
  });

  const checkTotalWorkingHours = () => {
    let totalWorkingHours =
      Number(
        timeStringToArithFloat({
          timeValue: floatToTimeString({ float: watch("monday") }),
        })
      ) +
      Number(
        timeStringToArithFloat({
          timeValue: floatToTimeString({ float: watch("tuesday") }),
        })
      ) +
      Number(
        timeStringToArithFloat({
          timeValue: floatToTimeString({ float: watch("wednesday") }),
        })
      ) +
      Number(
        timeStringToArithFloat({
          timeValue: floatToTimeString({ float: watch("thursday") }),
        })
      ) +
      Number(
        timeStringToArithFloat({
          timeValue: floatToTimeString({ float: watch("friday") }),
        })
      ) +
      Number(
        timeStringToArithFloat({
          timeValue: floatToTimeString({ float: watch("saturday") }),
        })
      ) +
      Number(
        timeStringToArithFloat({
          timeValue: floatToTimeString({ float: watch("sunday") }),
        })
      );

    let workingHoursPerWeek =
      companyDetails?.companySettings?.[0]?.workingHoursPerWeek;

    const check =
      Number(totalWorkingHours).toFixed(2) <=
      Number(workingHoursPerWeek).toFixed(2);

    return {
      check: check,
      totalWorkingHours: Number(totalWorkingHours).toFixed(2),
      workingHoursPerWeek: Number(workingHoursPerWeek).toFixed(2),
    };
  };
  return (
    <div>
      <div className="addproduct-icon list icon">
        <h5>
          <Info className="add-info" />
          <span>Default Shift</span>
        </h5>
      </div>
      <div className="row form-row mb-5">
        <div className="col-3">
          <Input
            name="defaultShift"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.defaultShift ? "is-invalid" : ""
            }`}
            label="Default Shift"
            labelClassName="form-label"
            optionData={defaultShiftOptions}
            required={false}
            requiredMessage="Default Shift is required"
            onChange={(selectedOption) => {
              setValue("defaultShift", Number(selectedOption));
              trigger("defaultShift");
            }}
            defaultValue={watch("defaultShift") !== 0 ? watch("defaultShift") : null}
          />
        </div>
      </div>

      <div className="addproduct-icon list icon">
        <h5>
          <Info className="add-info" />
          <span>Working Time Details</span>
        </h5>
      </div>

      <div className="table-responsive" style={{ minHeight: "250px" }}>
        <table className="table ">
          <thead>
            <tr>
              <th>-</th>
              <th>Monday</th>
              <th>Tuesday</th>
              <th>Wednesday</th>
              <th>Thursday</th>
              <th>Friday</th>
              <th>Saturday</th>
              <th>Sunday</th>
              {/* <th>Created By</th>
              <th>Created Date</th>
              <th>Updated By</th>
              <th>Updated Date</th> */}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Link className="me-2 p-2" onClick={() => setShow(!show)}>
                  <Edit className="feather-edit" />
                </Link>
              </td>
              <td>{watch("monday")}</td>
              <td>{watch("tuesday")}</td>
              <td>{watch("wednesday")}</td>
              <td>{watch("thursday")}</td>
              <td>{watch("friday")}</td>
              <td>{watch("saturday")}</td>
              <td>{watch("sunday")}</td>
              {/* <td></td>
              <td></td>
              <td></td>
              <td></td> */}
            </tr>
          </tbody>
        </table>
      </div>

      <WorkingHoursPopup
        show={show}
        handleClose={() => setShow(!show)}
        checkTotalWorkingHours={checkTotalWorkingHours}
      />
    </div>
  );
};

export default WorkingHours;
